module.exports = __webpack_public_path__ + "img/fitt_card_back.4d8dd481.svg";